<div quill-editor-toolbar>
  <span class="ql-formats">
    <select class="ql-header" title="Heading">
      <option value="1"></option>
      <option value="2"></option>
      <option value="3"></option>
      <option value="4"></option>
      <option value="5"></option>
      <option selected="selected"></option>
    </select>
  </span>
  <span class="ql-formats">
    <button class="ql-bold" title="Bold"></button>
    <button class="ql-italic" title="Italic"></button>
    <button class="ql-underline" title="Underline"></button>
    <button class="ql-strike" title="Strike"></button>
  </span>
  <span class="ql-formats">
    <button class="ql-link" title="Link"></button>
    <button class="ql-blockquote" title="Block Quote"></button>
    <button class="ql-code-block" title="Code Block"></button>
    <button class="ql-script" value="sub" title="Subscript"></button>
    <button class="ql-script" value="super" title="Superscript"></button>
  </span>
  <span class="ql-formats">
    <button class="ql-list" value="ordered" title="Ordered List"></button>
    <button class="ql-list" value="bullet" title="Bullet List"></button>
    <button class="ql-indent" value="-1" title="Increase Indent"></button>
    <button class="ql-indent" value="+1" title="Decrease Indent"></button>
  </span>
  <span class="ql-formats">
    <select class="ql-color" title="Font Color">
      <option selected></option>
      <option value="#ffffff"></option>
      <option value="#eeeeee"></option>
      <option value="#808080"></option>
      <option value="#ff0000"></option>
      <option value="#00ff00"></option>
      <option value="#0000ff"></option>
    </select>
    <select class="ql-background" title="Background Color">
      <option selected></option>
      <option value="#eeeeee"></option>
      <option value="#808080"></option>
      <option value="#000000"></option>
      <option value="#ff0000"></option>
      <option value="#00ff00"></option>
      <option value="#0000ff"></option>
    </select>
  </span>
  <span class="ql-formats">
    <select class="ql-align" title="Aligment">
      <option selected></option>
      <option value="center"></option>
      <option value="right"></option>
      <option value="justify"></option>
    </select>
  </span>
</div>
<div quill-editor-container></div>
